import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-notfound',
  template: `<section class="content pt-5">
  <div class="container-fluid">
    <div class="row pt-5">
      <div class="col-12 text-center">
        <div class="error-page">
          <img src="../../assets/img/ems-logo.png" class="logo">
        </div>
      </div>
      <div class="col-12 text-center">
        <div class="error-page">
          <h5><i class="fas fa-exclamation-triangle text-danger"></i> {{message}}
          </h5>
          <hr>
          <a href="/#/login">
            <i class="fa fa-chevron-circle-left mr-2"></i>
            Back to login
          </a>
        </div>
      </div>
    </div>
  </div>
</section>
  `,
  styles: [`
  .logo{
    max-width: 500px !important;
}
@media screen and (max-width: 600px) {
    .logo {
      max-width: 200px !important;
    }
  }
  `]
})
export class Page404Component implements OnInit {
    message:string="";
    constructor(private route: ActivatedRoute){}

  ngOnInit() {
    this.message = this.route.snapshot.params.message
  }

}